import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a49ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-category" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Индекс налёта ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Пародонтология ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Карта Ёршиков ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Карта рисков ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "report-category__row",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: _normalizeClass(_ctx.plaqueIndexBtnClasses),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGetReports(_ctx.REPORT_VIEW.plaqueIndex)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: _normalizeClass(_ctx.periodontalBtnClasses),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleGetReports(_ctx.REPORT_VIEW.periodontal)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { justify: "space-between" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: _normalizeClass(_ctx.brushBtnClasses),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleGetReports(_ctx.REPORT_VIEW.brushMap)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: _normalizeClass(_ctx.riskMapBtnClasses),
              disabled: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleGetReports(_ctx.REPORT_VIEW.riskMap)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}